import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import useIsMobile from "@Hooks/selector/useIsMobile";

export default function useShowRightStatusBadges(route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType) {
    const isMobile = useIsMobile()

    const {
        prices: {
            discounts,
        },
        status: {
            status,
            isSuggestion,
        },
    } = route

    const getShowDiscountsBadge = () => {
        const hasDiscounts = !isSuggestion && !!Object.keys(discounts)?.length && status === "open"

        return hasDiscounts && isMobile
    }

    return {
        showDiscountsBadge: getShowDiscountsBadge(),
    }
}